/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // ── Force mega menu on desktop — prevent hamburger/compress mode ──
  // The theme JS measures nav item widths and collapses to a hamburger if
  // they don't fit. Setting window.minWidth to 0 on desktop prevents this.
  // Mobile (<768px) retains its hamburger naturally via CSS media queries.
  function forceDesktopMegaMenu() {
    if (window.innerWidth >= 768) {
      window.minWidth = 0;
      var header = document.querySelector('header-component');
      if (header) header.classList.remove('site-header--compress');
    }
  }

  forceDesktopMegaMenu();
  window.addEventListener('resize', forceDesktopMegaMenu);
  setTimeout(forceDesktopMegaMenu, 100);
  setTimeout(forceDesktopMegaMenu, 500);

  // ── Tighten nav item padding so menu fits without overlapping logo ──
  var navStyle = document.createElement('style');
  navStyle.textContent = '.navlink--toplevel { padding-left: 10px !important; padding-right: 10px !important; }';
  document.head.appendChild(navStyle);




  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

